import Layout from "components/platform/Layout";
import Markdown from "markdown-to-jsx";
import React from "react";

export default function Privacy() {
  return (
    <Layout title="Humanloop – Privacy Policy">
      <div className="container-xl">
        <main className="prose m-16 mx-auto max-w-prose">
          <Markdown>{input}</Markdown>
        </main>
      </div>
    </Layout>
  );
}

const input = `
## Humanloop, Ltd's Privacy Policy

### About us

---

We are **Humanloop, Ltd**. Our full company name is Humanloop, Ltd our registered office is located in **United Kingdom**.

If you would like to contact us with a question about how we use your data, the quickest way to do this is by contacting our Data Protection Officer Jordan Burgess via email at privacy@humanloop.com.

This notice also explains how California residents can exercise their rights under the CCPA to request that we: (1) provide certain personal information that we have collected about them during the past 12 months, along with related information described below, or (2) delete certain personal information that we have collected from them.

### Why do we collect data?

---

We may use your personal information to permit the operational functioning of Humanloop, Ltd and features thereof (“business purposes”). In this case, your personal information will be processed in such a fashion that is necessary and proportionate to the business purpose for which it was collected, and strictly within the limits of compatible operational purposes.

We may also use your personal information for other reasons such as for commercial purposes, as well as for complying with the law and defend our rights before the competent authorities in case our rights and interests are threatened or we suffer an actual damage.

In particular, we use your personal information for the following purposes:

1. To faciliate the account creation and logon process
2. To enforce our terms and conditions and policies
3. To provide the service and fulfil your requests about it
4. to protect our rights and interests, or those of all our Users or third parties
5. to protect our safety, and those of all our Users or third parties
6. to detect any malicious, deceptive, fraudulent, or illegal activity, and prosecute those responsible for that activity
7. to respond to law enforcement requests, as required by the law, court orders or other governmental authorities
8. to detect security incidents and fix them
9. to debug Humanloop, Ltd in order to identify and repair errors that impair existing intended functionality
10. to undertake internal research for technological development as well as for constant verification and improvement of the quality and safety of Humanloop, Ltd and the Service
11. To faciliate the delivery of service of our product/service to our users
12. Fullfil and manage orders
13. to answer your assistance inquiries and your contact requests, including those related to the exercise of your privacy rights
14. to communicate with you, through the means described in Humanloop, Ltd, about any news, offers, events or other initiatives regarding our service
15. to request feedback and post testimonials
16. To faciliate payments
17. To monitor payments and purchases for fraud
18. To recommend other products and services that might be of interest to the user
19. to perform analyses about the use of Humanloop, Ltd
20. to audit and improve your interactions with Humanloop, Ltd and concurrent transactions thereof
21. Enable user to user communication

+ For all other purposes as described when we collect your personal information on Humanloop, Ltd

### What data do we collect?

---

| Category   | Data points  |  
|----------|-------------|
| Identifiers |  Account Identifier, Country, Email Address, IPAddress, Location, Name, Password, Physical Address, Username |
| Internet Information |    Browsing Behavior, IPAddress, Link Clicked   |
| California Consumer Records statute information | Country, Name, Password |
| Geolocation Data | Location, Physical Address |

### Who do we share this data with?


### Legal Basis

---

We collect personal information based on a number of legal basis including:

✓ **consent**

✓ **contract**

### How do we collect this data?

---

We obtain your personal information when you provide it to us (e.g., where you contact us via email or telephone, or by any other means). For example, you directly provide your personal information through your submissions or requests made via https://humanloop.com.

We also receive personal information indirectly when you navigate https://humanloop.com, as personal information about you and usage details are automatically observed and collected (such as device type, operating system, browser type, browser settings, IP address, language settings, dates and times of connecting to https://humanloop.com and other technical communications information).

In particular, we collect your personal information from:

✓ Forms

✓ Analytics tools & Software

✓ Surveys

✓ In person

✓ Over the phone

✓ Purchased from lists

### Where is your data stored and how long do we keep it?

---

We store your data in United States of America and United Kingdom

We will only retain your personal information for as long as we need it.

We consider the nature, sensitivity and purpose we collected your data for when deciding when it’s time to delete it. We will in some cases keep your data for longer periods of time than necessary for the original purpose we collected it for if we need to do this to meet our legal, accounting or regulatory requirements.

We also carefully anonymise your personal data so that it can no longer be associated with you, and because this information is anonymised, we can use it indefinitely without notifying you. We use this anonymised information to improve our business, and we also sell it to other businesses to help keep our service as low priced as possible.

### What are my rights?

---

### Under GDPR

1. Access your personal data (also known as a “subject access request”)
2. Correct incomplete or inaccurate data we hold about you
3. Ask us to erase the personal data we hold about you
4. Ask us to restrict our handling of your personal data
5. Ask us to transfer your personal data to a third party
6. Object to how we are using your personal data
7. Withdraw your consent to us handling your personal data

### Under CCPA

You have the right to request that we disclose to you:

1. The categories of personal information we collected about you
2. The categories of sources for the personal information we collected about you
3. Our business or commercial purpose for using your personal information
4. The categories of third parties with whom we share that personal information
5. The specific pieces of personal information that we hold about you

In case of sale of personal data, we will make sure that you receive two separate lists where we disclose:

1. Sales, identifying the personal information categories that each category of recipient purchased; and
2. Disclosures for a business purpose, identifying the personal information categories that each category of recipient obtained.
3. The disclosure described above will be limited to the personal information collected or used over the past 12 months.
4. If we deliver our answer electronically, the information enclosed will be "portable", i.e. delivered in an easy usable format in order to enable you to transmit the information to another entity without hindrance, provided that this is technically feasible.

You have the right to request that we delete any of your personal information, subject to the following exceptions:

1. If we need your personal information to complete the transaction for which we collected the personal information, provide a good or service that you requested, or otherwise perform our agreement with you.
2. Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities
3. Debug products to identify and repair errors that impair existing intended functionality of https://humanloop.com
4. Exercise free speech or exercise another right provided for by law
5. Comply with any legal obligation that lies with us
6. Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest
7. Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us
8. Make any other internal and lawful uses of your personal information in such a fashion that is compatible with the context in which you provided it.
9. If none of the exceptions above applies, as a result of the exercise of your right, we will delete your personal information and direct any of our service providers to do so.

To exercise the rights described above, you need to submit your verifiable request to us by: writing us an email at the contact details provided in this document, or, if it is the case, follow the specific instructions provided on https://humanloop.com

For us to respond to your request, it’so necessary that we know who you are.

Therefore, you can only exercise the above rights by making a verifiable request which must: provide sufficient information that allows us to reasonably verify you are the person about whom we collected personal information or an authorized representative.

Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to it. We will not respond to any request if we are not able to verify your identity and confirm the personal information in our possession actually relates to you.

If you cannot personally submit a verifiable request, you can authorize a person registered with the California Secretary of State to act on your behalf. If you are an adult, you can make a verifiable request on behalf of a minor under your parental authority.

You can submit a maximum number of 2 requests over a period of 12 months.

### Sale of Personal Information

---

We have not, sold personal information that is subject to the CCPA’s sale limitations. The CCPA defines a “sale” as the disclosure of personal information for monetary or other valuable consideration.

### Transfer of Assets

---

If our business is sold, we will transfer the personal information we hold about you to the buyer of our business. We do this because we have a legitimate interest to ensure that our business can be continued by the buyer.

### Transfers outside of the EU

---

Whenever we transfer your personal information outside of the UK and the EU, we ensure it receives additional protection as required by law. To keep this privacy policy as short and easy to understand as possible, we haven’t set out the specific circumstances when each of these protection measures are used. You can contact us at privacy@humanloop.com for more detail on this.

### Questions, Comments or More details

---

We’ve worked hard to create a notice that’s easy to read and clear. But if you feel that we have overlooked an important perspective or used language which you think we could improve, please let us know by email at privacy@humanloop.com. Your feedback and suggestions on this notice are welcome. This privacy policy was last updated on **2020-07-15.**

### Changes to this notice

---

We may change or update this Notice periodically. When we do, we will post the revised Notice on this web page indicating when the Notice was “Last Updated.”
    `;
